module.exports = __webpack_public_path__ + "static/img/shousuo.png@2x.79da7408.png";